module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu_circle",
    class: {
      'btn_topbar_active': _vm.topBarConfig.user.ucode
    }
  }, [_c('label', {
    attrs: {
      "for": "klickbox-step-add-buttons-container"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "klickbox-step-add-buttons-container"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepHasOnlyThanks),
      expression: "stepHasOnlyThanks"
    }],
    staticClass: "btn_circle-tooltip"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.add_one_question')))]), _vm._v(" "), _c('div', {
    staticClass: "menu_circle-list"
  }, [_c('span', {
    staticClass: "btn_circle btn_circle__red",
    attrs: {
      "title": "múltipla escolha"
    },
    on: {
      "click": function($event) {
        return _vm.stepAdd('multiple-choice')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-alternative"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn_circle-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.question')))])]), _vm._v(" "), _c('span', {
    staticClass: "btn_circle btn_circle__pink",
    attrs: {
      "title": "sim/não"
    },
    on: {
      "click": function($event) {
        return _vm.stepAdd('yes-no')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-yes-no"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn_circle-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.yes_no')))])]), _vm._v(" "), _c('span', {
    staticClass: "btn_circle btn_circle__purple",
    attrs: {
      "title": "texto"
    },
    on: {
      "click": function($event) {
        return _vm.stepAdd('text')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn_circle-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.text')))])]), _vm._v(" "), _c('span', {
    staticClass: "btn_circle btn_circle__blue",
    attrs: {
      "title": "e-mail"
    },
    on: {
      "click": function($event) {
        return _vm.stepAdd('email')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-register"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn_circle-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.capture'))), _c('br'), _vm._v(_vm._s(_vm.$t('edit.sidebar.of_email')))])]), _vm._v(" "), _c('span', {
    staticClass: "btn_circle btn_circle__green",
    attrs: {
      "title": "link"
    },
    on: {
      "click": function($event) {
        return _vm.stepAdd('redirect')
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-link"
  }), _vm._v(" "), _c('span', {
    staticClass: "btn_circle-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.redirec')) + "-"), _c('br'), _vm._v(_vm._s(_vm.$t('edit.sidebar.tion')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn_circle btn_circle__big"
  }, [_c('i', {
    staticClass: "kp-panel-plus"
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-33682f87!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/list/ButtonAdd.vue
 ** module id = 795
 ** module chunks = 1
 **/